import { IProductOption, ProductOptionValueInterface  } from '../interfaces';

export class ProductOption implements IProductOption {
  name = '';
  multiple = false;
  required = false;
  minSelections: number | undefined;
  maxSelections: number | undefined;
  values: ProductOptionValueInterface[] = [];
}
